import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const PlusIcon = ({
  color = 'foraBlue',
  width = 14,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <g fill="none" fillRule="evenodd">
        <path fill={getSemanticTextColor(color)} d="M10.576 6v1H7v3.576H6V7H2.424V6h3.575L6 2.423h1v3.575L10.577 6z" />
      </g>
    </svg> */}
    <svg viewBox="0 0 14 14" fill={getSemanticTextColor(color)} xmlns="http://www.w3.org/2000/svg">
      <path d="M6.42184 1.21523C6.42184 0.895727 6.68085 0.636719 7.00035 0.636719C7.31986 0.636719 7.57887 0.895727 7.57887 1.21523V12.7855C7.57887 13.105 7.31986 13.364 7.00035 13.364C6.68085 13.364 6.42184 13.105 6.42184 12.7855V1.21523Z" />
      <path d="M12.7855 6.42184C13.105 6.42184 13.364 6.68085 13.364 7.00035C13.364 7.31986 13.105 7.57887 12.7855 7.57887H1.21523C0.895727 7.57887 0.636719 7.31986 0.636719 7.00035C0.636719 6.68085 0.895727 6.42184 1.21523 6.42184H12.7855Z" />
    </svg>
  </DefaultIconWrapper>
);
